import React from 'react';
import { useParallax } from '../hooks/useParallax';
export function BeAGuestCTA() {
  const {
    ref,
    style
  } = useParallax(0.2);
  return <section className="relative bg-eofa-black py-24 md:py-40 overflow-hidden" data-id="element-24">
      {/* Parallax Background Shape */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none" data-id="element-25">
        <div ref={ref} className="w-[600px] h-[600px] md:w-[800px] md:h-[800px] bg-eofa-yellow/10 rounded-full blur-[100px]" style={style} data-id="element-26" />
      </div>

      <div className="container relative z-10 mx-auto px-6 text-center" data-id="element-27">
        <h2 className="text-eofa-white font-heading font-black text-[30px] md:text-[48px] leading-[1.1] tracking-tighter mb-6 max-w-[800px] mx-auto" data-id="element-28">
          Are you an Arizona business owner with a story worth telling?
        </h2>
        <p className="text-eofa-body text-base md:text-lg max-w-[700px] mx-auto mb-10" data-id="element-29">
          We're always looking for the next great conversation. Pitch yourself
          or someone you know. We respond to every submission.
        </p>
        <button className="bg-eofa-yellow text-eofa-black font-bold rounded-md px-10 min-h-[56px] text-lg hover:bg-yellow-400 transition-colors" data-id="element-30">
          Apply to Be a Guest
        </button>
      </div>
    </section>;
}